<p>
  middleware-client works!
</p>
